import BulkDeleteModal from "../../../../components/BulkDeleteModal";
import { deleteAlarmHandling } from "../../../../core/api/responsecenters/responsecenters";
import useTranslations from "../../../../core/i18n/useTranslations";

export const DeleteAlarmHandlingModal = ({
  isOpen,
  responseCenterId,
  ids,
  onClose,
  onDelete,
}: {
  isOpen: boolean;
  responseCenterId: number;
  ids: number[];
  onClose: () => void;
  onDelete: (success: boolean) => void;
}) => {
  const t = useTranslations();

  return (
    <BulkDeleteModal
      isOpen={isOpen}
      onClose={onClose}
      onDelete={onDelete}
      ids={ids.map((id) => id.toString())}
      labels={{
        single: t("AlarmReceptions:alarm_handling_type"),
        multi: t("AlarmReceptions:alarm_handling_type_multi"),
      }}
      apiFunc={(id, authReq) =>
        deleteAlarmHandling(responseCenterId, id, authReq)
      }
    />
  );
};
